var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "alert alert-info alert-icon" },
    [
      _c("i", { staticClass: "fa fa-arrow-right" }),
      _vm._v(
        "\n  Please pay the final amount to continue with this booking.\n  "
      ),
      _c(
        "router-link",
        {
          attrs: {
            to: {
              name: "payments.show",
              params: {
                bookingId: _vm.booking.id,
                action: "process",
                paymentId: _vm.bookingPaymentFinal.id,
              },
            },
          },
        },
        [_vm._v("\n    Go to payment\n  ")]
      ),
      _vm._v(".\n"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }